import { useAppContext } from '../../Services/AppContext';
import SearchWorkplaceNoResults from './SearchWorkplaceNoResults';
import SearchWorkplaceResult from './SearchWorkplaceResult';
import { useState } from 'react';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { gql } from '@apollo/client';
import * as React from 'react';
import SearchMD from '../SearchMD/SearchMD';

export default function SearchWorkplace({
	handleClick,
	gqlParams,
	hideEmptySearch = false,
}) {
	const { translation } = useAppContext();
	const [items, setItems] = useState(null);
	const [fulltext, setFulltext] = useState('');

	const searchQuery = gql`
		query Workplaces($fulltext: String!) {
			workplaces(fulltext: $fulltext, type: "normal") {
				data {
					id
					name
				}
			}
		}
	`;

	const handleSearch = text => {
		setFulltext(text);
	};

	const variables = { fulltext, ...gqlParams };

	// @ts-ignore
	useEffectAsync(async () => {
		if (!hideEmptySearch || fulltext.length > 2) {
			const result = await apiClient.graphql({
				query: searchQuery,
				variables: variables,
				fetchPolicy: 'network-only',
			});
			setItems(result?.data?.workplaces?.data || []);
		} else {
			setItems(null);
		}
	}, [fulltext, hideEmptySearch]);

	const itemsContent = items?.length ? (
		items.map((item, index) => (
			<SearchWorkplaceResult
				key={index}
				workplace={item}
				handleClick={handleClick}
			/>
		))
	) : (
		<SearchWorkplaceNoResults />
	);

	return (
		<SearchMD
			resultContent={items !== null ? itemsContent : null}
			handleSearch={handleSearch}
			placeholder={
				translation['base.shared.enterWorkplaceNameWhichYouAreLookingFor']
			}
		/>
	);
}
